import { GlobalToken, Switch, SwitchProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

export interface EPSwitchProps extends SwitchProps {
  value?: boolean;
  onLabel?: string;
  offLabel?: string;
}

const EPSwitch = (props: EPSwitchProps) => {
  const handleLabelClick = (newValue: boolean) => {
    props.onChange?.(newValue, {} as React.MouseEvent<HTMLButtonElement>);
  };

  return (
    <Container className={props.className}>
      {props.offLabel && (
        <span className={`off-container ${!props.value && 'unselected'}`} onClick={() => handleLabelClick(false)}>
          {props.offLabel}
        </span>
      )}
      <Switch checked={props.value ?? props.checked} {...props} aria-pressed={props.value ?? false} />
      {props.onLabel && (
        <span className={`on-container ${props.value && 'unselected'}`} onClick={() => handleLabelClick(true)}>
          {props.onLabel}
        </span>
      )}
    </Container>
  );
};

export default EPSwitch;

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;

  .on-container,
  .off-container {
    color: ${({ theme: { token } }) => token.colorText};
    transition: opacity 0.5s ease, color 0.3s ease;
    cursor: pointer;
  }

  .off-container {
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
  }

  .on-container {
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
  }

  .unselected {
    opacity: 0.32;
  }

  .on-container:hover,
  .off-container:hover {
    color: ${({ theme: { token } }) => token.colorText};
  }
`;
